import React, { useRef } from "react";
import PosterCard from "@/components/film/PosterCard";
import { Navigation, Thumbs, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { VerticalCard, Featured } from "@/components/publications/Cards";
import breakpoints from "@/constants/breakpoinst";
import * as Text from "@/components/text";
import classNames from "classnames";
import useWindowSize from "@/hooks/useWindowSize";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

export default function PublicationsCatalog({
  publications = [],
  title = "",

  ...rest
}) {
  const windowSize = useWindowSize();
  const beforeRef = useRef(null);
  const afterRef = useRef(null);
  return (
    <div {...rest} className="w-full">
      <div className="flex items-center justify-center pb-5 align-middle ">
        <div className="flex grow flex-row  md:space-y-5">
          <Text.Headline as="h2" size="md" className="inline-flex md:hidden">
            {title}
          </Text.Headline>
          <Text.Headline
            as="span"
            className="ml-5 inline-flex  text-neutral-400 md:hidden"
            fontWeight="light"
            size="md"
          >
            ({publications.length})
          </Text.Headline>
          <Text.Display
            size="sm"
            className="hidden text-neutral-700 md:inline-flex"
          >
            {title}
          </Text.Display>
          <Text.Display
            size="sm"
            as="span"
            className="ml-5 hidden text-neutral-400 md:inline-flex"
            fontWeight="light"
          >
            ({publications.length})
          </Text.Display>
        </div>

        {publications.length > 2 ? (
          <div className="hidden flex-row-reverse py-5 align-top  md:flex">
            <div
              ref={afterRef}
              className="amb-next-button cursor-pointer p-2 hover:bg-neutral-50"
            >
              <ArrowRightIcon className=" h-4 w-4 text-neutral-700  "></ArrowRightIcon>
            </div>
            <div className="relative top-[16px] mr-3 w-5 border-t border-neutral-700"></div>
            <div className="relative top-[15px] ml-3 mr-1 w-5 border-t-2 border-neutral-700"></div>
            <div
              ref={beforeRef}
              className=" amb-prev-button cursor-pointer p-2 hover:bg-neutral-50"
            >
              <ArrowLeftIcon className=" h-4 w-4 text-neutral-700  "></ArrowLeftIcon>
            </div>
          </div>
        ) : null}
      </div>

      {publications.length > 2 ? (
        <Swiper
          slidesPerView={1}
          breakpoints={{
            [breakpoints.xl]: {
              slidesPerView: 5,
              slidesPerGroup: 5,
              spaceBetween: 20,
            },
            [breakpoints.lg]: {
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 20,
            },
            [breakpoints.md]: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              spaceBetween: 24,
            },
            [breakpoints.sm]: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 24,
            },
          }}
          modules={[Thumbs, Navigation]}
          watchSlidesProgress={true}
          spaceBetween={10}
          navigation={{
            enabled: true,
            nextEl: afterRef.current,
            prevEl: beforeRef.current,
          }}
        >
          {publications.map((post) => (
            <SwiperSlide key={post.id}>
              <VerticalCard
                key={post.id}
                metadata={{
                  date: new Date(post.attributes.publishedAt),
                  type: "Noticia",
                  length: "",
                }}
                description={post.attributes.contenido}
                title={post.attributes.titulo}
                image={post.attributes.cover_image.data.attributes.url}
                link={`/blog/${post?.attributes?.slug}` || ""}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : null}
      {publications.length <= 2 ? (
        <div className="grid-cols-2 gap-5 space-y-5 md:grid">
          {publications.map((post, i) => (
            <div key={post.id}>
              <Featured
                metadata={{
                  date: new Date(post.attributes.publishedAt),
                  type: "Noticia",
                  length: "",
                }}
                aspect={
                  windowSize.width > breakpoints.md ? "rectangle" : "square"
                }
                description={post.attributes.contenido}
                title={post.attributes.titulo}
                image={post.attributes.cover_image.data.attributes.url}
                link={`/blog/${post?.attributes?.slug}` || ""}
              />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
